export default __webpack_public_path__ + "static/media/City of colors II.3c33019c.jpg";